import AsertoNameValidator from './AsertoNameValidator'

const ConnectionNameValidator = AsertoNameValidator

export default ConnectionNameValidator
